export interface Currency {
  name: string;
  symbol: string;
}

export const CURRENCIES: Currency[] = [
  { name: 'AED', symbol: 'د.إ' },
  { name: 'ARS', symbol: '$' },
  { name: 'AUD', symbol: '$' },
  { name: 'BRL', symbol: 'R$' },
  { name: 'CAD', symbol: '$' },
  { name: 'CHF', symbol: 'CHF' },
  { name: 'CLP', symbol: '$' },
  { name: 'CNH', symbol: '¥' },
  { name: 'CNY', symbol: '¥' },
  { name: 'CZK', symbol: 'Kč' },
  { name: 'DKK', symbol: 'kr' },
  { name: 'EGP', symbol: '£' },
  { name: 'EUR', symbol: '€' },
  { name: 'GBP', symbol: '£' },
  { name: 'HKD', symbol: '$' },
  { name: 'HUF', symbol: 'Ft' },
  { name: 'IDR', symbol: 'Rp' },
  { name: 'ILS', symbol: '₪' },
  { name: 'INR', symbol: '₹' },
  { name: 'ISK', symbol: 'kr' },
  { name: 'JOD', symbol: 'JD' },
  { name: 'JPY', symbol: '¥' },
  { name: 'KRW', symbol: '₩' },
  { name: 'KWD', symbol: 'KD' },
  { name: 'MXN', symbol: '$' },
  { name: 'MYR', symbol: 'RM' },
  { name: 'NGN', symbol: '₦' },
  { name: 'NOK', symbol: 'kr' },
  { name: 'NZD', symbol: '$' },
  { name: 'PHP', symbol: '₱' },
  { name: 'PKR', symbol: '₨' },
  { name: 'PLN', symbol: 'zł' },
  { name: 'QAR', symbol: '﷼' },
  { name: 'RON', symbol: 'lei' },
  { name: 'RUB', symbol: '₽' },
  { name: 'SAR', symbol: '﷼' },
  { name: 'SEK', symbol: 'kr' },
  { name: 'SGD', symbol: '$' },
  { name: 'THB', symbol: '฿' },
  { name: 'TRY', symbol: '₺' },
  { name: 'TWD', symbol: 'NT$' },
  { name: 'USD', symbol: '$' },
  { name: 'UYU', symbol: '$U' },
  { name: 'VND', symbol: '₫' },
  { name: 'ZAR', symbol: 'R' },
];

export const getCurrencyDisplay = (currency: Currency): string => {
  return `${currency.name} (${currency.symbol})`;
};
